import React from 'react'
import PropTypes from 'prop-types'

import headerImage from 'images/analytics/header.png'

function AnalyticsAbout({ participant }) {
  return (
    <div className="dashboard-card--analytics__about">
      <div className="row">
        <div className="col-12 col-md-6 col-xl-5 offset-xl-1">
          <div className="hero-text">
            <h1 className="hero-text__title">
              <a href="/profile/analytics/about">Analytics</a>
            </h1>
            <p>Analytics is a set of extensive historic and real-time insights about market trends and
              your 3D models. The insights are based on lifetime data from CGTrader: customer searches,
              available models and orders completed on.
            </p>
            <a href="/profile/analytics/about" className="btn btn-secondary">
              {participant ? 'Go to Analytics' : 'Join Analytics'}
            </a>
          </div>
        </div>
        <div className="col-12 col-md-6 hero-image">
          <img src={headerImage} alt="Analytics" />
        </div>
      </div>
    </div>
  )
}

AnalyticsAbout.propTypes = {
  participant: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
}

AnalyticsAbout.defaultPropTypes = {
  participant: false,
}

export default AnalyticsAbout
